export const hotspotEditInfo = {
    editExcludeFields: []
}